import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import * as proposalService from "../../../services/service/proposalService"
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const ProjectLogComponent = (props) => {
    const { auth } = props;
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchProjectLogs();
    }, [])

    const fetchProjectLogs = () => {
        proposalService.GetProposalProjectLogs().then(res => {
            setData(res);
        }).catch(ex => {
            console.log("Something went wrong!!");
        })
    }

    const columns = [
        {
            name: "projectNumber",
            label: "Project #",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'project-number',
                    'data-aes-label': 'Project #',
                    style: { width: "9%" }
                }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div>
                            {
                                (auth.isAdmin || auth.isProjectManager || auth.isTechnician) ?
                                    <Link
                                        to={data[dataIndex].jobId !== 0 ? "/services/manage-job/general-information/" + data[dataIndex].jobId : "/services/manage-proposal/general-information/" + data[dataIndex].id}>
                                        {data[dataIndex].projectNumber}
                                    </Link> :
                                    <p>{data[dataIndex].projectNumber}</p>
                            }

                        </div>
                    )
                },
            }
        },
        {
            name: "createdDateTime",
            label: "Date Created",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'date-created',
                    'data-aes-label': 'Date Created'
                }),
            }
        },
        {
            name: "client",
            label: "Client",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'client',
                    'data-aes-label': 'Client'
                }),
            }
        },
        {
            name: "projectType",
            label: "Project Type",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'project-type',
                    'data-aes-label': 'Project Type'
                }),
            }
        },
        {
            name: "projectSubType",
            label: "ProjectSubType",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'project-sub-type',
                    'data-aes-label': 'Project Sub Type'
                }),
            }
        },
        {
            name: "projects",
            label: "Projects",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'project',
                    'data-aes-label': 'Project'
                }),
            }
        },
        {
            name: "clientLocation",
            label: "Client Location",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'client-location',
                    'data-aes-label': 'Client Location'
                }),
            }
        },
        {
            name: "referralSource",
            label: "Referral Source",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'referral-source',
                    'data-aes-label': 'Referral Source'
                }),
            }
        },
        {
            name: "projectManager",
            label: "Project Manager",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'project-manager',
                    'data-aes-label': 'Project Manager'
                }),
            }
        }
    ];

    return (
        <div className="col-lg-12 col-xxl-12 aes-admin-listing-page aes-admin-listing-page--project-logs">
            <div className={`card card-custom card-stretch gutter-b}`}>
                <div className="card-header border-0 py-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            Project Logs
                        </span>
                    </h3>
                </div>
                <div className="container-fluid aes-admin-listing">
                    <MUIDataTable
                        className="aes-admin-listing-surface"
                        data={data}
                        columns={columns}
                        options={{
                            responsive: 'standard',
                            rowsPerPage: 25,
                            selectableRows: 'none',
                            rowsPerPage: 25,
                            fixedHeader: true,
                            fixedSelectColumn: true,
                            tableBodyHeight: '90vh',
                            setTableProps: () => ({
                                className: 'aes-admin-listing-table'
                            })
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(ProjectLogComponent);
